import { useInfiniteQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { PaginatedResponse } from "@/queries/types";
import { promptLabel } from "@/schemas";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export const useInfinitePromptLabels = ({
  userToken,
  workspace_id,
  prompt_id,
  per_page = 50,
  enabled = true,
}: {
  userToken: string;
  workspace_id: number;
  prompt_id?: number;
  per_page?: number;
  enabled?: boolean;
}) =>
  useInfiniteQuery<PaginatedResponse<promptLabel.Response[], "prompt_labels", string>>({
    queryKey: [
      ENDPOINTS.prompt_labels(workspace_id),
      "infinite",
      userToken,
      workspace_id,
      prompt_id,
      per_page,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const url = new URL(ENDPOINTS.prompt_labels(workspace_id));
      url.searchParams.set("workspace_id", workspace_id.toString());
      if (prompt_id) {
        url.searchParams.set("prompt_id", prompt_id.toString());
      }
      url.searchParams.set("per_page", per_page.toString());
      url.searchParams.set("page", pageParam.toString());

      const response = await fetch(url.toString(), {
        headers: authHeader(userToken),
      });

      return handleResponse(response);
    },
    getNextPageParam: lastPage => (lastPage.has_next ? lastPage.next_num : undefined),
    getPreviousPageParam: firstPage => (firstPage.has_prev ? firstPage.prev_num : undefined),
    enabled: enabled && !!userToken && !!workspace_id,
    keepPreviousData: true,
  });
